/* Native dialogs provide Escape handling and a focus boundary. Dawn owns the cart. */
if (!customElements.get('nl-site-header')) {
  customElements.define('nl-site-header', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.listeners = [];
      this.dialogTriggers = new WeakMap();
      const options = false;
      this.prepareDialogs();
      this.querySelectorAll('[data-nl-open]').forEach((button) => {
        this.listen(button, 'click', () => {
          const dialog = this.querySelector(`[data-nl-dialog="${button.dataset.nlOpen}"]`);
          if (!dialog) return;
          this.closeDisclosures();
          this.querySelectorAll('dialog[open]').forEach((openDialog) => openDialog.close());
          this.dialogTriggers.set(dialog, button);
          button.setAttribute('aria-expanded', 'true');
          dialog.showModal();
          document.documentElement.classList.add('nl-dialog-open');
          if (button.dataset.nlOpen === 'search') this.focusIfPresent(dialog.querySelector('input[type="search"]'));
        }, options);
      });
      this.querySelectorAll('dialog').forEach((dialog) => {
        dialog.querySelectorAll('[data-nl-close]').forEach((button) => this.listen(button, 'click', () => dialog.close(), options));
        this.listen(dialog, 'click', (event) => {
          if (event.target !== dialog) return;
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        }, options);
        this.listen(dialog, 'close', () => {
          const trigger = this.dialogTriggers.get(dialog);
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          if (!this.querySelector('dialog[open]')) {
            document.documentElement.classList.remove('nl-dialog-open');
            if (trigger) trigger.focus();
          }
        }, options);
      });
      this.hoverTimers = new Set();
      const hoverViewport = window.matchMedia('(min-width: 1200px) and (hover: hover) and (pointer: fine)');
      this.querySelectorAll('.nl-nav-disclosure').forEach((disclosure) => {
        const summary = disclosure.querySelector('summary');
        let timer;
        let openedByHover = false;
        const cancelTimer = () => {
          clearTimeout(timer);
          this.hoverTimers.delete(timer);
        };
        const schedule = (action, delay) => {
          cancelTimer();
          timer = setTimeout(() => { this.hoverTimers.delete(timer); action(); }, delay);
          this.hoverTimers.add(timer);
        };
        if (disclosure.closest('.nl-desktop-nav')) { const hoverTarget = disclosure.closest('.nl-department-nav, .nl-surf-nav') || disclosure;
          this.listen(hoverTarget, 'pointerenter', (event) => {
            if (event.pointerType !== 'mouse' || !hoverViewport.matches) return;
            cancelTimer();
            if (!disclosure.open) schedule(() => {
              this.closeDisclosures();
              disclosure.open = true;
              openedByHover = true;
            }, 140);
          }, options);
          this.listen(hoverTarget, 'pointerleave', (event) => {
            if (event.pointerType !== 'mouse') return;
            schedule(() => {
              if (!disclosure.contains(document.activeElement)) {
                disclosure.open = false;
                openedByHover = false;
              }
            }, 260);
          }, options);
          this.listen(summary, 'click', (event) => {
            cancelTimer();
            if (openedByHover && disclosure.open) event.preventDefault();
            openedByHover = false;
          }, options);
        }
        this.listen(summary, 'keydown', (event) => {
          if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
          event.preventDefault();
          disclosure.open = true;
          const links = [...disclosure.querySelectorAll('.nl-mega a[href]')];
          this.focusIfPresent(event.key === 'ArrowUp' ? links[links.length - 1] : links[0]);
        }, options);
        this.listen(disclosure, 'toggle', () => {
          if (!disclosure.open) return;
          disclosure.closest('nav').querySelectorAll('.nl-nav-disclosure[open]').forEach((other) => { if (other !== disclosure) other.open = false; });
        }, options);
        this.listen(disclosure, 'keydown', (event) => {
          if (event.key !== 'Escape' || !disclosure.open) return;
          event.preventDefault();
          event.stopPropagation();
          disclosure.open = false;
          summary.focus();
        }, options);
        this.listen(disclosure, 'focusout', () => {
          requestAnimationFrame(() => {
            if (disclosure.closest('.nl-desktop-nav') && !disclosure.contains(document.activeElement)) disclosure.open = false;
          });
        }, options);
      });
      this.listen(document, 'click', (event) => { if (!this.contains(event.target)) this.closeDisclosures(); }, options);
      this.listen(this, 'click', (event) => {
        const link = event.target.closest('a[href]');
        if (!link) return;
        this.closeDisclosures();
        const parentDialog = link.closest('dialog[open]'); if (parentDialog) parentDialog.close();
      }, options);
      this.listen(this, 'focusout', () => { requestAnimationFrame(() => { if (!this.contains(document.activeElement)) this.closeDisclosures(); }); }, options);
      // A promotional overlay must not interrupt an active shopping dialog.
      const dismissedPrompts = new WeakSet();
      const protectShopping = () => {
        this.shoppingFrame = null;
        const active = document.querySelector('quick-add-modal[open], cart-drawer.active, nl-site-header dialog[open], product-modal[open]');
        if (!active) return;
        document.querySelectorAll('[data-kl-scroll-locking-modal="true"]').forEach((prompt) => {
          const close = prompt.querySelector('button.klaviyo-close-form');
          if (!close || dismissedPrompts.has(prompt)) return;
          dismissedPrompts.add(prompt);
          close.click();
          requestAnimationFrame(() => {
            if (active.isConnected && !active.contains(document.activeElement)) {
              const focusTarget = active.querySelector('input[type="search"], input:checked, [role="dialog"][tabindex], button, a[href]');
              if (focusTarget) focusTarget.focus();
            }
          });
        });
      };
      this.shoppingObserver = new MutationObserver(() => {
        if (this.shoppingFrame == null) this.shoppingFrame = requestAnimationFrame(protectShopping);
      });
      this.shoppingObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class'] });
      protectShopping();
      this.viewport = window.matchMedia('(min-width: 1200px)');
      this.onViewportChange = () => {
        const menu = this.querySelector('[data-nl-dialog="menu"][open]'); if (this.viewport.matches && menu) menu.close();
        this.closeDisclosures();
      };
      if (this.viewport.addEventListener) this.viewport.addEventListener('change', this.onViewportChange);
      else this.viewport.addListener(this.onViewportChange);
    }
    listen(target, type, callback, options) {
      target.addEventListener(type, callback, options);
      this.listeners.push([target, type, callback, options]);
    }
    focusIfPresent(target) { if (target) target.focus(); }
    prepareDialogs() {
      this.querySelectorAll('dialog').forEach((dialog) => {
        if (typeof dialog.showModal === 'function') return;
        dialog.classList.add('nl-dialog-fallback');
        dialog.setAttribute('role', 'dialog');
        dialog.setAttribute('tabindex', '-1');
        dialog.showModal = () => {
          dialog.setAttribute('open', '');
          dialog.setAttribute('aria-modal', 'true');
          this.classList.add('nl-has-fallback-dialog');
          this.focusIfPresent(dialog.querySelector('button, input, a[href]') || dialog);
        };
        dialog.close = () => {
          if (!dialog.hasAttribute('open')) return;
          dialog.removeAttribute('open');
          dialog.removeAttribute('aria-modal');
          this.classList.remove('nl-has-fallback-dialog');
          dialog.dispatchEvent(new Event('close'));
        };
        this.listen(document, 'keydown', (event) => {
          if (!dialog.hasAttribute('open')) return;
          if (event.key === 'Escape') { event.preventDefault(); dialog.close(); return; }
          if (event.key !== 'Tab') return;
          const items = Array.from(dialog.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')).filter((el) => !el.disabled && el.tabIndex >= 0 && el.getClientRects().length);
          const first = items[0], last = items[items.length - 1];
          if (!first) { event.preventDefault(); dialog.focus(); }
          else if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
        }, false);
        this.listen(document, 'focusin', (event) => {
          if (dialog.hasAttribute('open') && !dialog.contains(event.target)) this.focusIfPresent(dialog.querySelector('button, input, a[href]') || dialog);
        }, false);
      });
    }
    closeDisclosures() { if (this.hoverTimers) this.hoverTimers.forEach(clearTimeout); if (this.hoverTimers) this.hoverTimers.clear(); this.querySelectorAll('.nl-desktop-nav .nl-nav-disclosure[open]').forEach((disclosure) => { disclosure.open = false; }); }
    disconnectedCallback() {
      if (this.shoppingObserver) this.shoppingObserver.disconnect();
      cancelAnimationFrame(this.shoppingFrame);
      if (this.hoverTimers) this.hoverTimers.forEach(clearTimeout);
      this.listeners.forEach((entry) => entry[0].removeEventListener(entry[1], entry[2], entry[3]));
      if (this.viewport) { if (this.viewport.removeEventListener) this.viewport.removeEventListener('change', this.onViewportChange); else this.viewport.removeListener(this.onViewportChange); }
      this.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
      document.documentElement.classList.remove('nl-dialog-open');
      this.initialized = false;
    }
  });
}

/* Inline size choices keep the selected variant explicit and use Dawn's cart. */
if (!customElements.get('nl-card-sizes')) {
  customElements.define('nl-card-sizes', class extends HTMLElement {
    connectedCallback() {
      if (this.sizeChange) return;
      this.sizeChange = (event) => {
        if (!event.target.matches('input[name="nl-card-size"]:checked')) return;
        const form = event.target.form;
        form.querySelector('input[name="id"]').value = event.target.value;
        const submit = form.querySelector('button[name="add"]');
        submit.disabled = false;
        submit.removeAttribute('aria-disabled');
      };
      this.addEventListener('change', this.sizeChange);
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.sizeChange);
      this.sizeChange = null;
    }
  });
}

/* Equalize size groups within each visible product row after layout changes. */
(() => {
  let frame;
  const align = () => {
    frame = null;
    const sets = Array.from(document.querySelectorAll('main .nl-card-sizes'));
    sets.forEach(set => { set.style.minHeight = ''; });
    const rows = new Map();
    sets.forEach(set => {
      const card = set.closest('.grid__item') || set.closest('.card-wrapper');
      if (!card || !card.getClientRects().length) return;
      const row = Math.round(card.getBoundingClientRect().top + window.scrollY);
      if (!rows.has(row)) rows.set(row, []);
      rows.get(row).push(set);
    });
    rows.forEach(row => {
      const height = Math.ceil(Math.max(...row.map(set => set.getBoundingClientRect().height)));
      row.forEach(set => { set.style.minHeight = height + 'px'; });
    });
  };
  const schedule = () => { if (frame == null) frame = requestAnimationFrame(align); };
  const init = () => {
    const main = document.querySelector('main');
    if (main) new MutationObserver(schedule).observe(main, {childList:true, subtree:true});
    window.addEventListener('resize', schedule, {passive:true});
    window.addEventListener('load', schedule, {once:true});
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
